import React from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield, User, ListChecks, Search, PackageSearch, Gift} from 'lucide-react';
import './RecommendationEngineLanding.css';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { useMediaQuery } from '@mui/material';
const features = [
  {
    icon: <User className="icon" />,
    title: 'Answer Simple Questions',
    description: 'Provide quick answers about your child’s interests, age, and play preferences through our easy-to-use form.'
  },
  {
    icon: <ListChecks className="icon" />,
    title: 'Personalized Input',
    description: 'Select specific activities or preferences such as “drawing”, “building”, or “outdoor play” to tailor the recommendations.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'AI-Driven Matching',
    description: 'Our AI analyzes your inputs and intelligently matches them with the most relevant toys from our database.'
  },
  {
    icon: <Search className="icon" />,
    title: 'Curated Toy Selection',
    description: 'We browse various trusted toy sources and websites to gather product information in real time.'
  },
  {
    icon: <PackageSearch className="icon" />,
    title: 'Smart Filtering',
    description: 'Toys are filtered based on age appropriateness, developmental benefits, and user preferences.'
  },
  {
    icon: <Gift className="icon" />,
    title: 'Instant Recommendations',
    description: 'Receive a list of personalized toy suggestions—perfectly matched to your child’s personality and interests.'
  }
];


const RecommendationEngineLanding = () => {
  const navigate = useNavigate();

  const onClickHandle = () => {
    navigate('/recommendation/login');
  };

  const isCustomSize = useMediaQuery("(max-width:770px)");
  return (
    <>
    <Header />
      <div className="recommendationengine" style={{padding : '30px'}}>
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Recommendation <span className="highlight">Engine</span> AI
              </h1>
              <p className="hero-description">
              Our AI delivers personalized toy suggestions in seconds, based on your child’s unique interests and preferences. Just answer a few simple questions—our system matches your input with the best-fit toys, making discovery fun, fast, and effortless.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              {!isCustomSize &&  <div style={{display : 'flex' , justifyContent : 'space-around'}}>
                <h2 className="features-heading">How It Works</h2>
                <h2 className="features-heading">What We Ask</h2>
              </div>}
              {isCustomSize && <h2 style={{fontSize : '22px'}} className="features-heading">What This AI Utility Does</h2>}
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button onClick={onClickHandle} className="cta-button">
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default RecommendationEngineLanding;
